import * as Statsig from '../statsig'

// TODO: Update these values once we have the contracts approved and uploaded
const DEFAULT_LOANPRO_POLICY_AND_PROCEDURES = {
  mesa_cardholder_agreement:
    'https://cdn.prod.website-files.com/66ba8f888ae5ad6954fd9036/68716b2b0eee69a73df745b6_CP-2%20CHA%20Mesa%20Homeowners%20Card.pdf',
  mesa_cardholder_agreement_preview_img:
    'https://assets.mesamember.com/mesa_card_holder_agreement_preview.png',
  mesa_privacy_policy: 'https://mesamember.com/legal/mesa-privacy-policy',
  celtic_bank_privacy_policy: 'https://www.celticbank.com/privacy',
  mesa_privacy_notice:
    'https://cdn.prod.website-files.com/66ba8f888ae5ad6954fd9036/68a37d540061a1023345f7ff_Mesa%20Privacy%20Notice.pdf',
  terms_of_service: 'https://www.mesamember.com/legal/mesa-membership-terms-and-conditions',
  'e-sign_consent_policy':
    'https://cdn.prod.website-files.com/66ba8f888ae5ad6954fd9036/6762e5fc2f03ea6fb897ce65_CPL-15a%202024%20Mesa%20E%20SIGN%20and%20UETA%20Policy.pdf',
  credit_report_authorization_notice:
    'https://cdn.prod.website-files.com/66ba8f888ae5ad6954fd9036/67240fa7d680ec6c940d4d63_Credit%20Report%20Authorization%20Mesa.pdf',
  cardholder_rewards_terms_of_use:
    'https://www.mesamember.com/legal/mesa-membership-terms-and-conditions',
  usa_patriot_act_notice:
    'https://cdn.prod.website-files.com/66ba8f888ae5ad6954fd9036/67240fa79ec6f0803fd5efbf_USA%20Patriot%20Act%20Disclosure.pdf',
  mesa_refer_a_cardholder_terms_and_conditions:
    'https://www.mesamember.com/legal/mesa-refer-a-friend-terms-and-conditions',
  partner: {
    lakeview: {
      cardholder_agreement:
        'https://www.mesamember.com/legal/lakeview/mesa-homeowners-visa-r-signature-preferred-credit-card-for-lakeview-cardholder-agreement',
      rewards_terms_of_use:
        'https://www.mesamember.com/legal/lakeview/mesa-homeowners-visa-r-signature-preferred-credit-card-for-lakeview-membership-terms-and-conditions',
      benefits_terms_of_use:
        'https://www.mesamember.com/legal/lakeview/mesa-homeowners-visa-r-signature-preferred-credit-card-for-lakeview-benefits-terms',
    },
    carrington: {
      cardholder_agreement:
        'https://www.mesamember.com/legal/carrington/mesa-homeowners-visa-r-signature-preferred-credit-card-for-carrington-cardholder-agreement',
      rewards_terms_of_use:
        'https://www.mesamember.com/legal/carrington/carrington-rewards-program-powered-by-mesa-terms-and-conditions',
      benefits_terms_of_use:
        'https://www.mesamember.com/legal/carrington/mesa-homeowners-visa-r-signature-preferred-credit-card-for-carrington-benefits-terms',
    },
  },
} as const satisfies Statsig.ParameterStores.CardPolicyAndProcedures

export function useTerms() {
  const cardPolicyAndProcedures = Statsig.ParameterStores.useCardPolicyAndProcedures()

  return {
    cardholderAgreementImage: cardPolicyAndProcedures.get(
      'mesa_cardholder_agreement_preview_img',
      DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.mesa_cardholder_agreement_preview_img,
    ),

    cardholderAgreementPdf: cardPolicyAndProcedures.get(
      'mesa_cardholder_agreement',
      DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.mesa_cardholder_agreement,
    ),
    cardholderAgreement: {
      title: 'Mesa Cardholder Agreement',
      link: cardPolicyAndProcedures.get(
        'mesa_cardholder_agreement',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.mesa_cardholder_agreement,
      ),
    },
    lakeviewCardholderAgreementPdf:
      cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
        ?.lakeview?.cardholder_agreement ??
      DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.lakeview.cardholder_agreement,
    lakeviewCardholderAgreement: {
      title: 'Lakeview Cardholder Agreement',
      link:
        cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
          ?.lakeview?.cardholder_agreement ??
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.lakeview.cardholder_agreement,
    },
    lakeviewRewardsTermsOfUse: {
      title: 'Lakeview Rewards Terms of Use',
      link:
        cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
          ?.lakeview?.rewards_terms_of_use ??
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.lakeview.rewards_terms_of_use,
    },
    carringtonCardholderAgreementPdf:
      cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
        ?.carrington?.cardholder_agreement ??
      DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.carrington.cardholder_agreement,
    carringtonCardholderAgreement: {
      title: 'Carrington Cardholder Agreement',
      link:
        cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
          ?.carrington?.cardholder_agreement ??
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.carrington.cardholder_agreement,
    },
    carringtonRewardsTermsOfUse: {
      title: 'Carrington Rewards Terms of Use',
      link:
        cardPolicyAndProcedures.get('partner', DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner)
          ?.carrington?.rewards_terms_of_use ??
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.partner.carrington.rewards_terms_of_use,
    },
    mesaPrivacyPolicy: {
      title: 'Mesa Privacy Policy',
      link: cardPolicyAndProcedures.get(
        'mesa_privacy_policy',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.mesa_privacy_policy,
      ),
    },
    bankPrivacyNotice: {
      title: 'Bank Privacy Notice',
      link: cardPolicyAndProcedures.get(
        'celtic_bank_privacy_policy',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.celtic_bank_privacy_policy,
      ),
    },
    mesaPrivacyNotice: {
      title: 'Mesa Privacy Notice',
      link: cardPolicyAndProcedures.get(
        'mesa_privacy_notice',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.mesa_privacy_notice,
      ),
    },
    termsOfService: {
      title: 'Terms of Service',
      link: cardPolicyAndProcedures.get(
        'terms_of_service',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.terms_of_service,
      ),
    },
    eSignConsentPolicy: {
      title: 'E-Sign Consent Policy',
      link: cardPolicyAndProcedures.get(
        'e-sign_consent_policy',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES['e-sign_consent_policy'],
      ),
    },
    creditReportAuthorizationNotice: {
      title: 'Credit Report Authorization Notice',
      link: cardPolicyAndProcedures.get(
        'credit_report_authorization_notice',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.credit_report_authorization_notice,
      ),
    },
    cardholderRewardsTermsOfUse: {
      title: 'Cardholder Rewards Terms of Use',
      link: cardPolicyAndProcedures.get(
        'cardholder_rewards_terms_of_use',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.cardholder_rewards_terms_of_use,
      ),
    },
    usaPatriotActNotice: {
      title: 'USA Patriot Act Notice',
      link: cardPolicyAndProcedures.get(
        'usa_patriot_act_notice',
        DEFAULT_LOANPRO_POLICY_AND_PROCEDURES.usa_patriot_act_notice,
      ),
    },
  }
}
